'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _elementType = require('react-prop-types/lib/elementType');

var _elementType2 = _interopRequireDefault(_elementType);

var _safeAttributes = require('./utils/safeAttributes');

var _safeAttributes2 = _interopRequireDefault(_safeAttributes);

var _styleMaps = require('./utils/styleMaps');

var _bootstrapUtils = require('./utils/bootstrapUtils');

var _SafeAnchor = require('./SafeAnchor');

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonStyles = _styleMaps.State.values().concat(_styleMaps.DEFAULT, _styleMaps.PRIMARY, _styleMaps.LINK);

var types = ['button', 'reset', 'submit'];

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button(props, context) {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props, context));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var classes = this.props.navDropdown ? {} : (0, _bootstrapUtils.getClassSet)(this.props);

      var blockClass = (0, _bootstrapUtils.prefix)(this.props, 'block');

      classes = _extends(_defineProperty({
        active: this.props.active
      }, blockClass, this.props.block), classes);

      if (this.props.navItem) {
        return this.renderNavItem(classes);
      }

      var renderFuncName = this.props.href || this.props.target || this.props.navDropdown ? 'renderAnchor' : 'renderButton';

      return this[renderFuncName](classes);
    }
  }, {
    key: 'renderAnchor',
    value: function renderAnchor(classes) {
      var _props = this.props,
          disabled = _props.disabled,
          href = _props.href;


      classes.disabled = disabled;

      return _react2.default.createElement(
        _SafeAnchor2.default,
        _extends({}, this.props, {
          href: href || '#',
          className: (0, _classnames2.default)(this.props.className, classes)
        }),
        this.props.children
      );
    }
  }, {
    key: 'renderButton',
    value: function renderButton(classes) {
      var Component = this.props.componentClass || 'button';
      var validProps = (0, _safeAttributes2.default)(this.props);
      return _react2.default.createElement(
        Component,
        _extends({}, validProps, {
          disabled: this.props.disabled || this.props.loading,
          type: this.props.type || 'button',
          className: (0, _classnames2.default)(this.props.className, classes) }),
        this.props.loading ? this.props.loadingText : this.props.children,
        this.props.loading && _react2.default.createElement(
          'span',
          { style: { display: 'block' }, className: 'fe-spinner btn-loading__spinner btn-loading__spinner--right' },
          _react2.default.createElement('span', { className: 'fe-spinner__load btn-loading__spinner--load' }),
          _react2.default.createElement('span', { className: 'fe-spinner__load btn-loading__spinner--load' }),
          _react2.default.createElement('span', { className: 'fe-spinner__load btn-loading__spinner--load' })
        )
      );
    }
  }, {
    key: 'renderNavItem',
    value: function renderNavItem(classes) {
      var liClasses = {
        active: this.props.active
      };

      return _react2.default.createElement(
        'li',
        { className: (0, _classnames2.default)(liClasses) },
        this.renderAnchor(classes)
      );
    }
  }]);

  return Button;
}(_react2.default.Component);

Button.propTypes = {
  active: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  navItem: _propTypes2.default.bool,
  navDropdown: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  /**
   * You can use a custom element for this component
   */
  componentClass: _elementType2.default,
  href: _propTypes2.default.string,
  target: _propTypes2.default.string,
  /**
   * Defines HTML button type Attribute
   * @type {("button"|"reset"|"submit")}
   * @defaultValue 'button'
   */
  type: _propTypes2.default.oneOf(types),
  loadingText: _propTypes2.default.string,
  loading: _propTypes2.default.bool
};

Button.defaultProps = {
  active: false,
  block: false,
  disabled: false,
  navItem: false,
  navDropdown: false,
  loadingText: 'loading',
  loading: false
};

Button.types = types;

exports.default = (0, _bootstrapUtils.bsStyles)(ButtonStyles, (0, _bootstrapUtils.bsSizes)([_styleMaps.Sizes.LARGE, _styleMaps.Sizes.SMALL, _styleMaps.Sizes.XSMALL], (0, _bootstrapUtils.bsClass)('btn', Button)));